import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export interface SelectOption {
  value: string
  label: string
  /** Verilirse seçenekler bu başlık altında gruplanır (yerel `<optgroup>` karşılığı). */
  group?: string
}

/**
 * Düz bir seçenek listesinden `ui/select`: yerel `<select>` yerine (DESIGN §5), yanındaki kontrollerle
 * aynı yükseklik ve köşe. Değer her zaman string; boş string "Tümü" gibi bir seçenek olabilir.
 */
export function OptionSelect({
  value,
  options,
  onValueChange,
  size = 'default',
  id,
  className,
  disabled,
  'aria-label': ariaLabel,
}: {
  value: string
  options: SelectOption[]
  onValueChange: (value: string) => void
  size?: 'sm' | 'default'
  id?: string
  className?: string
  disabled?: boolean
  'aria-label'?: string
}) {
  const items = options.map(({ value: item, label }) => ({ value: item, label }))
  const groups = [...new Set(options.map((option) => option.group))]

  return (
    <Select
      value={value}
      items={items}
      disabled={disabled}
      onValueChange={(next) => onValueChange(next ?? '')}
    >
      <SelectTrigger id={id} size={size} aria-label={ariaLabel} className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {groups.map((group) => (
          <SelectGroup key={group ?? ''}>
            {group && <SelectLabel>{group}</SelectLabel>}
            {options
              .filter((option) => option.group === group)
              .map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  )
}
